export default __webpack_public_path__ + "static/media/iconMapPinGradient.96dd50e9.svg";